// In browser builds, Vite replaces import.meta.env.VITE_* with the values
// from .env.* files. This module is fully mocked in Jest via src/env/__mocks__,
// so import.meta.env references here are never evaluated by the test runtime.

export const NODE_ENV = import.meta.env.MODE ?? 'development';
export const PUBLIC_URL = import.meta.env.BASE_URL ?? '/';
export const REACT_APP_SIMPLE_QUOTE_API_URL =
  import.meta.env.VITE_SIMPLE_QUOTE_API_URL ?? '';
export const REACT_APP_SIMPLE_QUOTE_API_TARGET_URL =
  import.meta.env.VITE_SIMPLE_QUOTE_API_TARGET_URL ?? '';
export const REACT_APP_GACODE = import.meta.env.VITE_GACODE ?? '';
export const REACT_APP_ENV = import.meta.env.VITE_ENV ?? '';
